/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductionInfoUpdate
 */
export interface ProductionInfoUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof ProductionInfoUpdate
     */
    forceCustomBatesStart?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionInfoUpdate
     */
    regenerateFilesFromOtherDocs?: boolean;
}

export function ProductionInfoUpdateFromJSON(json: any): ProductionInfoUpdate {
    return ProductionInfoUpdateFromJSONTyped(json, false);
}

export function ProductionInfoUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionInfoUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'forceCustomBatesStart': !exists(json, 'forceCustomBatesStart') ? undefined : json['forceCustomBatesStart'],
        'regenerateFilesFromOtherDocs': !exists(json, 'regenerateFilesFromOtherDocs') ? undefined : json['regenerateFilesFromOtherDocs'],
    };
}

export function ProductionInfoUpdateToJSON(value?: ProductionInfoUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'forceCustomBatesStart': value.forceCustomBatesStart,
        'regenerateFilesFromOtherDocs': value.regenerateFilesFromOtherDocs,
    };
}


